import { CITIES } from "@/data/content";

const Marquee = () => {
  const items = [...CITIES, "Pronto Intervento Nazionale"];
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((city) => (
        <span key={`${key}-${city}`} className="flex items-center">
          <span className="px-6 text-sm font-bold uppercase tracking-[0.25em] text-slate-500">
            {city}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#00B36B]" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="coverage-marquee"
      className="overflow-hidden border-y border-slate-100 bg-white py-5"
    >
      <div className="animate-marquee flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export default Marquee;
